import Cookies from "js-cookie";
export function getCookie(name) {
  return Cookies.get(name);
}
export function setCookie(name) {
  return Cookies.set(name);
}
